import { render, staticRenderFns } from "./Receipt.vue?vue&type=template&id=517d0ed8&scoped=true"
import script from "./Receipt.vue?vue&type=script&lang=ts"
export * from "./Receipt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517d0ed8",
  null
  
)

export default component.exports